module.exports = __webpack_public_path__ + "static/media/bevl-05.4788ade4.jpg";